<template>
  <b-modal
      ref="create-bonus"
      size="lg"
      :title="$t('bonus.create_bonus')"
  >
    <b-form>
      <b-form-group
          :label="$t('bonus.form.name')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.name"
            :state="!$v.form.name.$dirty ? null :(!$v.form.name.$error)"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.type')"
          label-for="status"
      >
        <b-form-select
            id="status"
            v-model="form.type"
            :options="options.types"
            @change="$v.form.type.$model = $event"
            :state="!$v.form.type.$dirty ? null :(!$v.form.type.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.currency')"
          label-for="status"
      >
        <b-form-select
            id="status"
            v-model="form.currency"
            :options="options.currencies"
            @change="$v.form.currency.$model = $event"
            :state="!$v.form.currency.$dirty ? null :(!$v.form.currency.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.description')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.description"
            :state="!$v.form.description.$dirty ? null :(!$v.form.description.$error)"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.valid_from')"
          label-for="validFrom"
          label-cols-lg="3"
      >
        <date-range-picker v-model="form.validFrom"
                           :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                           :auto="false"
                           :linked="false"
                           style="width: 100%;"
                           :singleDatePicker="true"
                           :show-week-numbers="false"
                           :time-picker="true"
                           filter-name="createdAt"
                           :ranges="false"
                           :opens="'center'"
                           :timePicker24Hour="false">
          <template v-slot:input="picker" style="width: 1350px;">
            {{ picker.startDate | date }}
          </template>
        </date-range-picker>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.valid_to')"
          label-for="validTo"
          label-cols-lg="3"
      >
        <date-range-picker v-model="form.validTo"
                           :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                           :auto="false"
                           :linked="false"
                           style="width: 100%;"
                           :singleDatePicker="true"
                           :show-week-numbers="false"
                           :time-picker="true"
                           filter-name="createdAt"
                           :ranges="false"
                           :opens="'center'"
                           :timePicker24Hour="false">
          <template v-slot:input="picker" style="width: 1350px;">
            {{ picker.startDate | date }}
          </template>
        </date-range-picker>
      </b-form-group>

      <b-form-group
          v-if="form.type === types.deposit"
          :label="$t('bonus.form.period')"
          label-for="status"
      >
        <b-form-select
            id="status"
            v-model="form.period"
            :options="options.periods"
            @change="$v.form.period.$model = $event"
            :state="!$v.form.period.$dirty ? null :(!$v.form.period.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <b-form-group
          v-if="form.type !== types.manual"
          :label="$t('bonus.form.is_bonus_code')"
          label-for="status"
      >
        <b-form-select
            id="status"
            v-model="form.isBonusCode"
            :options="options.isBonusCode"
            @change="$v.form.isBonusCode.$model = $event"
            :state="!$v.form.isBonusCode.$dirty ? null :(!$v.form.isBonusCode.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <template v-if="form.isBonusCode">
        <b-form-group v-for="(field,index) in form.bonusCodes" :key="index" :label="$t('bonus.form.bonus_codes')">
          <b-form-input v-model="field.value" :state="!$v.form.bonusCodes.$each[index].$dirty ? null : (!$v.form.bonusCodes.$each[index].$error)"/>
        </b-form-group>
      </template>

      <b-form-group
          :label="$t('bonus.form.trigger')"
          label-for="status"
      >
        <multiselect v-model="form.triggers"

                     label="text"
                     track-by="value"

                     :options="options.triggers"
                     :multiple="true"
                     >
        </multiselect>
      </b-form-group>

      <b-form-group
          v-if="form.type !== types.noDeposit && triggersHasDeposit.includes(true)"
          :label="$t('bonus.form.min_deposit')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.minDeposit"
            :state="!$v.form.minDeposit.$dirty ? null :(!$v.form.minDeposit.$error)"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.wager_type')"
          label-for="status"
      >
        <b-form-select
            id="status"
            v-model="form.wagerType"
            :options="options.wagerTypes"
            @change="$v.form.wagerType.$model = $event"
            :state="!$v.form.wagerType.$dirty ? null :(!$v.form.wagerType.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.wager_lock_type')"
          label-for="status"
      >
        <b-form-select
            id="status"
            v-model="form.wagerLockType"
            :options="options.wagerLockTypes"
            @change="$v.form.wagerLockType.$model = $event"
            :state="!$v.form.wagerLockType.$dirty ? null :(!$v.form.wagerLockType.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.wager_value')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.wagerValue"
            :state="!$v.form.wagerValue.$dirty ? null :(!$v.form.wagerValue.$error)"
            required
        ></b-form-input>
      </b-form-group>

<!--      MA BYC NIE WYMAGANY-->
      <b-form-group
          :label="$t('bonus.form.days_to_complete_wager')" label-for="input-2">
        <b-form-input
            id="input-2"
            type="number"
            v-model="form.daysToCompleteWager"
            :state="!$v.form.daysToCompleteWager.$dirty ? null :(!$v.form.daysToCompleteWager.$error)"
        ></b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.factor_type')"
          label-for="status"
      >
        <b-form-select
            id="status"
            v-model="form.factorType"
            :options="options.factorTypes"
            @change="$v.form.factorType.$model = $event"
            :state="!$v.form.factorType.$dirty ? null :(!$v.form.factorType.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.factor_value')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.factorValue"
            :state="!$v.form.factorValue.$dirty ? null :(!$v.form.factorValue.$error)"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.max_bonus_amount')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.maxBonusAmount"
            :state="!$v.form.maxBonusAmount.$dirty ? null :(!$v.form.maxBonusAmount.$error)"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.agreement_3_requirement')"
          label-for="status"
      >
        <b-form-select
            id="agreement3Requirement"
            v-model="form.agreement3Requirement"
            :options="options.agreementRequirement"
            @change="$v.form.agreement3Requirement.$model = $event"
            :state="!$v.form.agreement3Requirement.$dirty ? null :(!$v.form.agreement3Requirement.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <b-form-group
          :label="$t('bonus.form.agreement_4_requirement')"
          label-for="status"
      >
        <b-form-select
            id="agreement4Requirement"
            v-model="form.agreement4Requirement"
            :options="options.agreementRequirement"
            @change="$v.form.agreement4Requirement.$model = $event"
            :state="!$v.form.agreement4Requirement.$dirty ? null :(!$v.form.agreement4Requirement.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-1" @click="hideModal()">{{$t('btn.cancel')}}</b-button>
          <b-button variant="primary" :disabled="busy" @click="submit()">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
// import {required} from "vuelidate/lib/validators";
import axios from "axios";
import Multiselect from "vue-multiselect";
import DateRangePicker from "../../components/DateRangePicker/components/DateRangePicker";
import moment from "moment";
import {requiredIf} from "vuelidate/lib/validators";

export default {
  components: {
    Multiselect,
    DateRangePicker
  },
  props: {
    isEditType: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      dictionariesGetUrl: '/api/bonus-definition/dictionaries',
      busy: false,
      types: {
        deposit: 'DEPOSIT',
        manual: 'MANUAL',
        noDeposit: 'NO_DEPOSIT'
      },
      options: {
        isBonusCode: [
          {value: true, text: this.$t(`option.bonus.isBonusCode.yes`)},
          {value: false, text: this.$t(`option.bonus.isBonusCode.no`)}
        ],
        agreementRequirement: [
          {value: 'REQUIRED', text: this.$t(`option.bonus.agreementRequirement.required`)},
          {value: 'FORBIDDEN', text: this.$t(`option.bonus.agreementRequirement.forbidden`)},
          {value: 'DO_NOT_APPLY', text: this.$t(`option.bonus.agreementRequirement.do_not_apply`)}
        ],
        currencies: [],
        factorTypes: [],
        periods: [],
        statuses: [],
        triggers: [],
        types: [],
        wagerLockTypes: [],
        wagerTypes: [],
      },
      form: {
        name: '',
        type: '',
        currency: '',
        description: '',
        period: '',
        validFrom: {
          startDate: ''
        },
        validTo: {
          startDate: ''
        },
        isBonusCode: '',
        bonusCodes: [{
          value: ''
        }],
        triggers: [],
        wagerType: '',
        wagerValue: '',
        wagerLockType: '',
        daysToCompleteWager: '',
        factorType: '',
        factorValue: '',
        maxBonusAmount: '',
        minDeposit: null,
        agreement3Requirement: '',
        agreement4Requirement: ''
      },
    }
  },
  validations: {
    form: {
      name: {

      },
      type: {

      },
      currency: {

      },
      description: {

      },
      validFrom: {

      },
      validTo: {

      },
      period: {

      },
      isBonusCode: {

      },
      triggers: {

      },
      bonusCodes: {
        $each: {
          value: {

          }
        }
      },
      wagerType: {

      },
      wagerValue: {

      },
      wagerLockType: {

      },
      daysToCompleteWager: {

      },
      factorType: {

      },
      factorValue: {

      },
      maxBonusAmount: {

      },
      minDeposit: {

      },
      agreement3Requirement: {
        required: requiredIf(function() {
          return this.triggersRegistration && this.triggersRegistration.includes(true);
        })
      },
      agreement4Requirement: {
        required: requiredIf(function() {
          return this.triggersRegistration && this.triggersRegistration.includes(true);
        })
      }
    }
  },
  filters: {
    date: function (value) {
      if (value) {
        return new moment(value).format('YYYY-MM-DD hh:mm a');
      }
    },
  },
  mounted() {
    if(this.isEditType) {
      // this.form = {
      //   name: this.data.name ? this.data.name : '',
      //   type: this.data.type ? this.data.type : '',
      //   currency: this.data.currency ? this.data.currency : '',
      //   description: this.data.description ? this.data.description : '',
      //   validFrom: {
      //     startDate: this.data.validFrom && this.data.validFrom.startDate ? this.data.validFrom.startDate : ''
      //   },
      //   validTo: {
      //     startDate: this.data.validFrom && this.data.validFrom.validTo ? this.data.validFrom.validTo : ''
      //   },
      //   isBonusCode: this.data.isBonusCode ? this.data.isBonusCode : '',
      //   bonusCodes: [{
      //     value: ''
      //   }],
      //   triggers: [],
      //   wagerType: '',
      //   wagerValue: '',
      //   wagerLockType: '',
      //   daysToCompleteWager: '',
      //   factorType: '',
      //   factorValue: '',
      //   maxBonusAmount: '',
      //   minDeposit: ''
      // }
    }
    this.getDictionaries();
  },
  computed: {
    triggersHasDeposit: function() {
      return this.form.triggers.map(trigger => {
        return trigger.value === 'DEPOSIT';
      });
    },
    triggersRegistration: function() {
      return this.form.triggers.map(trigger => {
        return trigger.value === 'REGISTRATION';
      });
    }
  },
  methods: {
    submit() {
      this.$v.$touch();

      const triggers = this.form.triggers.map(trigger => {
        return trigger.value;
      });

      const bonusCodes = this.form.bonusCodes.map(trigger => {
        return trigger.value;
      });

      const payload = {
        ...this.form,
        isBonusCode: this.form.isBonusCode ? this.isBonusCode : false,
        period: this.form.type === this.types.deposit ? this.form.period : 'NONE',
        bonusCodes: bonusCodes,
        triggers: triggers,
        daysToCompleteWager: Number(this.form.daysToCompleteWager),
        validFrom: this.form.validFrom.startDate,
        validTo: this.form.validTo.startDate,
        minDeposit: this.form.minDeposit ? this.form.minDeposit : null
      }

      if(!this.$v.invalid) {
        axios.post('/api/bonus-definition/create', payload).then(() => {
            this.hideModal();
            this.$parent.$emit('refreshGrid')
          })
          .catch((err) => {
            console.log(err);
          })
      }
    },
    getDictionaries() {
      axios.get(this.dictionariesGetUrl)
        .then((resp) => {
          // resp.data.forEach(dict => {
          //   this.options
          // });

          for (const [key] of Object.entries(resp.data)) {

            const options = resp.data[key].map(item => {
              return {
                value: item, text: this.$t(`option.bonus.${key}.${item.toLowerCase()}`)
              }
            });

            this.options[key] = options;
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    openModal() {
      this.$refs['create-bonus'].show();
    },
    hideModal() {
      this.$refs['create-bonus'].hide();
    }
  }
}
</script>
